import {Box,Autocomplete,TextField,Tooltip} from '@mui/material';
import {DefaultConfig,evaluateReadOnly} from '../../../core/utilities/Utilities';
const readOnlyBackgroundColor=DefaultConfig.readOnlyBackgroundColor;

const FieldAutocomplete=({row,fieldName,application,recordRules,readOnly,setFieldValue})=>{
    const fieldProp=row?.[fieldName];
    const readOnlyEvaluated=evaluateReadOnly(readOnly,recordRules,fieldProp);
    const fieldTextColor=fieldProp?.ui_text_color||null;
    const lovName=fieldProp?.list_of_values;
    const value=fieldProp.value?fieldProp?.value:null;
    const options=(()=>{
        if(!lovName) return [];
        const lovMap=application?.globalData?.list_of_values?.[lovName]||{};
        const dynamicCodes=fieldProp?.list_of_values_dynamic;
        const codes=Array.isArray(dynamicCodes)&&dynamicCodes.length>0?dynamicCodes:Object.keys(lovMap);
        return codes.map((code)=>lovMap?.[code]).filter(Boolean);
    })();
    return (
        <Box sx={{flex:1,minWidth:0}}>
            <Autocomplete
                style={{marginTop:"0px"}}
                readOnly={readOnlyEvaluated}
                fullWidth
                options={options}
                getOptionLabel={(option)=>option}
                id={fieldName}
                name={fieldName}
                type={fieldProp?.ui_type}
                size="small"
                value={value}
                onChange={(event,newValue)=>{setFieldValue(fieldName,newValue);}}
                renderInput={(params)=>(
                    <Tooltip
                        placement="top"
                        title={fieldProp?.ui_tooltip?application.getLocale(fieldProp?.ui_tooltip):''}
                        disableHoverListener={!fieldProp?.ui_tooltip}>
                    <TextField {...params} 
                        sx={{
                            div:{backgroundColor:readOnlyEvaluated?readOnlyBackgroundColor:""},
                            input:fieldTextColor?{color:fieldTextColor}:undefined}}
                        style={{marginTop:"0px",marginBottom:"8px"}}
                        fullWidth
                        required={fieldProp?.required?fieldProp?.required:false}
                        error={fieldProp?.validation_error?fieldProp?.validation_error:false}
                        helperText={fieldProp?.validation_error_message?fieldProp?.validation_error_message:''}
                        size="small"
                        variant="outlined"
                        label={fieldProp?.ui_label_locale?application.getLocale(fieldProp?.ui_label_locale):fieldName}
                        margin="normal"
                    />
                    </Tooltip>
                )}
            />
        </Box>
    );
}

export default FieldAutocomplete;
